import { DocumentNode, print } from 'graphql/language';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { getHttpServiceWithCredentials } from '@phoenix/core/frontend/shared/domain/http/http.factory';

export const useGraphqlFetcher = <T extends { errors?: { message: string }[] }>(document: DocumentNode, url?: string) => {
  const client = getHttpServiceWithCredentials(url);
  const {
    auth: { user },
  } = useCore();

  const localeCountry = user?.country;

  return async (variables?: Record<string, unknown>) => {
    const response = await client.post<T, Record<string, any>>(
      '/',
      {
        query: print(document),
        variables,
      },
      {
        headers: {
          ...(!!localeCountry && { 'x-accept-country': localeCountry }),
        },
      }
    );

    if (response.errors) {
      throw response.errors.map((e) => e.message);
    }

    return response;
  };
};
